/** @jsx jsx */
import { useState, useEffect } from 'react'
import { jsx, Text } from 'theme-ui';
import Single from './single'
import { getStats } from '../../api/opta'
import style from './statistic.style'

const Statistic = (props) => {

  const [stats, setStats] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    (async () =>  {
      const stats = await getStats(props.optaFixtureId)
      setLoading(false)
      if (!stats.success || !stats.data)
        return
      setStats(stats.data)
    })()

  }, [
    setStats,
    props.optaFixtureId
  ])

  if (loading) {
    return <Text sx={style.message}>Loading</Text>
  }

  if (!loading && !stats.length) {
    return <Text sx={style.message}>Not available</Text>
  }

  return stats?.map((x,i) => {
    return <Single
      key={i}
      heading={x.label}
      left={{amount: x.home.amount, label: x.home.label}}
      right={{amount: x.away.amount, label: x.away.label}}
    />
  })
}

export default Statistic
